import styled from 'styled-components'
export const S_ClientFundingRequest = styled.div`
  width: 600px;
  max-width: 100%;
  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
  }
  .submit-row {
    display: flex;
    justify-content: space-around;
    margin-top: 32px;
  }
  h2 {
    margin-bottom: 32px;
  }
  .field-row {
    max-width: 200px;
  }
`
